import Vue from "vue";
import Router from "vue-router";

import Login from "./components/Login.vue";
import Home from "./components/Home.vue";
import DeviceDetail from "./components/device/DeviceDetail.vue";

import AdminUser from "./components/admin/AdminUser.vue";
import AdminContact from "./components/admin/AdminContactList.vue";
import AdminI18N from "./components/admin/AdminI18N.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/device/:id",
      name: "device",
      component: DeviceDetail,
      props: true
    },
    {
      path: "/users",
      name: "adminUser",
      component: AdminUser,
    },
    {
      path: "/contacts",
      name: "adminContact",
      component: AdminContact,
    },
    {
      path: "/translations",
      name: "adminI18N",
      component: AdminI18N,
    },
  ],
});
